import { render } from "./PageContentHeader.vue?vue&type=template&id=2ea147b4&scoped=true"
import script from "./PageContentHeader.vue?vue&type=script&lang=js"
export * from "./PageContentHeader.vue?vue&type=script&lang=js"

import "./PageContentHeader.vue?vue&type=style&index=0&id=2ea147b4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea147b4"]])

export default __exports__